/**
 * Import required libraries
 */
import React from "react";
import { connect } from "react-redux";

/**
 * Import required elements
 */
import { App, Footer, Loading } from "Components";
import NavMenu from "./NavMenu";
import Routes from "./Routes";
import styles from "./styles";
import { Background } from "Components";


/**
 * Platform Render JSX
 */
const Platform = ({ loaded, dataLoaded, socketConnected, authenticated }) => {

  const classes = styles();

  if (loaded) {
    return (
      <Background className={classes.background}>
        <App footer={dataLoaded && authenticated && <Footer />}>
          {dataLoaded && authenticated ? <NavMenu /> : null}
          <Routes />
        </App>
      </Background>
    );
  } else return <Loading absolute />;
};

export default connect(state => ({
  dataLoaded: state.simtopy.dataLoaded,
  socketConnected: state.simtopy.socketConnected,
  authenticated: state.user.authenticated
}))(Platform);
